/**
 * 計算調整後的購物車數量
 * 如果 training_hours < 1，則使用 Math.ceil(amount * training_hours)
 * 否則直接返回原始 amount
 */
export const useCartAmount = () => {
  const calculateAdjustedAmount = (amount: number, trainingHours?: number): number => {
    if (trainingHours !== undefined && trainingHours < 1) {
      return Math.ceil(amount * trainingHours)
    }
    return amount
  }

  return {
    calculateAdjustedAmount
  }
}
